<template>
 <ai-form-text-box :field-key="meta.fieldKey" title="Наименование" :serverData="serverData" :userData="userData" @userDataChanged="userDataChanged"/>
</template>

<script setup>
import AiFormTextBox from '@/components/card-component/ai-form-text-box.vue';
const props = defineProps({
  meta: {
    type: Object,
    default: () => {}
  },
  serverData: {
    type: Object,
    default: () => {}
  },
  userData: {
    type: Object,
    default: () => {}
  },
  callbacks: {
    type: Object,
    default: () => ({userDataChanged: null})
  }
})

const userDataChanged = (array) => {
  props.callbacks.userDataChanged(array)
}
</script>
